module.exports = __webpack_public_path__ + "media/images/amenities_icons/event-space-cd40f08b0bae2f0d45a46ed1df6403c4.svg";